import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { GraduationCap, Award, Quote } from 'lucide-react';
export function AboutSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-16 md:py-32 bg-white" id="about" data-id="element-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start" data-id="element-4">
          {/* Image Column - 40% */}
          <div className="w-full lg:w-[40%] relative max-w-sm mx-auto lg:max-w-none" data-id="element-5">
            <div className="relative z-10" data-id="element-6">
              <img src="https://cdn.magicpatterns.com/uploads/5Rk82FQzqcVJkW3VxhvpdW/M-Ailawadi.jpg" alt="Dr. Maneesh Ailawadi" className="w-full h-auto object-cover shadow-2xl rounded-b-2xl" style={{
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0
            }} data-id="element-7" />
              <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-[#0d9488]/10 rounded-full blur-3xl -z-10" data-id="element-8"></div>
            </div>

            {/* Quote Box */}
            <div className="mt-8 sm:mt-12 relative pl-8 sm:pl-10 border-l-4 border-[#0d9488]" data-id="element-9">
              <Quote className="absolute top-0 left-2 w-6 h-6 sm:w-8 sm:h-8 text-[#0d9488]/20 transform -scale-x-100" data-id="element-10" />
              <p className="text-base sm:text-xl italic text-slate-700 font-serif leading-relaxed" data-id="element-11">
                {t('"My goal is to provide safe, effective surgical care that helps patients reclaim their health and quality of life."', '"Mi objetivo es brindar atención quirúrgica segura y efectiva que ayude a los pacientes a recuperar su salud y calidad de vida."')}
              </p>
              <p className="mt-3 sm:mt-4 font-bold text-[#0f172a]" data-id="element-12">
                — Dr. Ailawadi
              </p>
            </div>
          </div>

          {/* Content Column - 60% */}
          <div className="w-full lg:w-[60%]" data-id="element-13">
            <div className="pl-5 sm:pl-6 border-l-4 border-[#0d9488] mb-6 sm:mb-8" data-id="element-14">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#0f172a] mb-2" data-id="element-15">
                {t('About Dr. Ailawadi', 'Sobre el Dr. Ailawadi')}
              </h2>
              <p className="text-base sm:text-lg text-[#0d9488] font-medium" data-id="element-16">
                MD, FSSO — Board Certified Surgeon
              </p>
            </div>

            <div className="prose prose-lg prose-slate max-w-none text-slate-600 mb-12" data-id="element-17">
              <p className="leading-relaxed" data-id="element-18">
                {t('Expert general and bariatric surgeon at Lehigh Valley Weight Loss in Allentown and Bethlehem, PA. Has helped thousands of people achieve better health with weight-loss surgery.', 'Cirujano general y bariátrico experto en Lehigh Valley Weight Loss en Allentown y Bethlehem, PA. Ha ayudado a miles de personas a lograr una mejor salud con cirugía de pérdida de peso.')}
              </p>

              <p data-id="element-19">
                {t('Dr. Ailawadi has extensive experience operating on the stomach and esophagus, utilizing advanced minimally invasive techniques to ensure faster recovery and better outcomes for his patients.', 'El Dr. Ailawadi tiene amplia experiencia operando el estómago y el esófago, utilizando técnicas avanzadas mínimamente invasivas para asegurar una recuperación más rápida y mejores resultados para sus pacientes.')}
              </p>
            </div>

            {/* Education Timeline */}
            <div className="mb-12" data-id="element-20">
              <h3 className="flex items-center text-xl font-bold text-[#0f172a] mb-6" data-id="element-21">
                <GraduationCap className="w-6 h-6 text-[#0d9488] mr-3" data-id="element-22" />
                {t('Education & Training', 'Educación y Formación')}
              </h3>

              <div className="space-y-6 border-l-2 border-slate-100 ml-3 pl-8 relative" data-id="element-23">
                {['Fellowship — Thoracic Surgery at Vanderbilt University', 'Research — Memorial Sloan Kettering Cancer Center', 'Residency — University of Illinois College of Medicine', 'Medical School — Chicago Medical School', 'BS Biology — Carnegie Mellon University'].map((item, index) => <div key={index} className="relative" data-id="element-24">
                    <div className="absolute -left-[39px] top-1.5 w-4 h-4 rounded-full bg-white border-2 border-[#0d9488]" data-id="element-25"></div>
                    <p className="text-slate-700 font-medium" data-id="element-26">{item}</p>
                  </div>)}
              </div>
            </div>

            {/* Approach Box */}
            <div className="bg-[#0f172a] p-8 rounded-xl text-white shadow-xl relative overflow-hidden group" data-id="element-27">
              <div className="absolute top-0 right-0 w-64 h-64 bg-[#0d9488] rounded-full mix-blend-multiply filter blur-[64px] opacity-20 group-hover:opacity-30 transition-opacity" data-id="element-28"></div>

              <h3 className="text-xl font-bold text-white mb-4 flex items-center relative z-10" data-id="element-29">
                <Award className="w-6 h-6 text-[#0d9488] mr-3" data-id="element-30" />
                {t('Approach to Care', 'Enfoque de atención')}
              </h3>

              <p className="text-slate-300 leading-relaxed relative z-10" data-id="element-31">
                {t("Dr. Ailawadi believes in patient education, shared decision-making, and prioritizing safety above all else. Every treatment plan is tailored to the individual's unique medical history and personal goals.", 'El Dr. Ailawadi cree en la educación del paciente, la toma de decisiones compartida y la priorización de la seguridad ante todo. Cada plan de tratamiento se adapta al historial médico único y los objetivos personales del individuo.')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}